import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getGallery, removeGallery, toggleGallery } from 'slice/gallerySlice';
import AdminTable from 'common/AdminTable';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';

const GalleryList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const galleryState = useSelector((state) => state.gallery);
  const items = Array.isArray(galleryState?.data) ? galleryState.data : [];
  const loading = galleryState?.loading;

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    {
      Header: 'Name',
      accessor: 'name',
      Cell: ({ row }) => row.original.name || '-'
    },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) => (
        <img
          src={`${process.env.REACT_APP_BACKEND}${row.original.image}`}
          alt={row.original.name || 'gallery'}
          className="banner-thumb"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )
    },
    {
      Header: 'Status',
      accessor: 'is_active',
      Cell: ({ row }) => (
        <span className={`badge ${row.original.is_active ? 'badge-success' : 'badge-danger'}`}>
          {row.original.is_active ? 'Active' : 'Inactive'}
        </span>
      )
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <div className="d-flex flex-wrap" style={{ gap: 6 }}>
          <button className="btn btn-sm btn-info" onClick={() => navigate(`/gallery/update/${row.original.id}`)}>
            Edit
          </button>
          <button
            className={`btn btn-sm ${row.original.is_active ? 'btn-warning' : 'btn-success'}`}
            onClick={() => dispatch(toggleGallery(row.original.id))}
          >
            {row.original.is_active ? 'Deactivate' : 'Activate'}
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => {
              if (window.confirm(`Are you sure you want to delete "${row.original.name || 'this image'}"?`)) {
                dispatch(removeGallery(row.original.id));
                toast.success('Gallery image deleted successfully');
              }
            }}
          >
            Delete
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    dispatch(getGallery());
  }, [dispatch]);

  return (
    <div className="container-fluid px-4">
      <div className="d-flex justify-content-between align-items-center my-4 flex-wrap" style={{ gap: '0.75rem' }}>
        <div>
          <h2 className="m-0">Gallery</h2>
          <small className="text-muted">Manage hospital gallery images</small>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/gallery/add')}>
          <FaPlus /> Add Image
        </button>
      </div>

      <div className="card shadow mb-4">
        <div className="card-body p-0">
          {loading && items.length === 0 ? (
            <div className="text-center p-5">Loading...</div>
          ) : (
            <AdminTable tableHeaders={tableHeaders} tableData={items} />
          )}
        </div>
      </div>
    </div>
  );
};

export default GalleryList;
